import { IS_PRODUCTION } from 'shared/config/env';
import { cratChain, wagmiConfig } from 'shared/config/wagmi';
import { getContract } from 'viem';

import { WUSD_ABI } from '../abi';

const address = {
  testnet: '0x664dE8AC58D8B7378B161f2cc78134E177C42d0B',
  mainnet: '0x47f79bA8fA8453730cbe0c4cDfF19E37345Cca3c',
} as const;

export const wusdtContract = getContract({
  abi: WUSD_ABI,
  address: IS_PRODUCTION ? address.mainnet : address.testnet,
  client: wagmiConfig.getClient({
    chainId: cratChain.id,
  }),
});
